<template>
  <div>
    <div class="template chatSystem">
      <div class="itemBtn" v-if="chatType==1">
        <div v-if="util.isNotEmpty(userID)" class="chatMasking"></div>
        <el-badge :value="serviceMarks.waitAcceptNum>0?serviceMarks.waitAcceptNum:''" class="item">
          <el-button type="primary" @click="goWaitAccept">{{$t('im.commonChat.waitAccept')}}</el-button>
        </el-badge>
        <el-badge :value="serviceMarks.waitAssessmentNum>0?serviceMarks.waitAssessmentNum:''" class="item">
          <el-button type="primary" @click="goEvaluated()">{{$t('im.commonChat.waitEvaluated')}}</el-button>
        </el-badge>
        <el-badge :value="serviceMarks.waitReceiveNum>0?serviceMarks.waitReceiveNum:''" class="item">
          <el-button type="primary" @click="goAcceptSession()">{{$t('im.commonChat.acceptSession')}}</el-button>
        </el-badge>
        <el-badge class="item">
          <el-button type="primary" @click="goChatMonitor()" v-auth="'im:chatSystem:artificialChat:serviceMonitor'">{{$t('im.commonChat.chatMonitor')}}</el-button>
        </el-badge>
        <el-badge class="item">
          <el-button type="primary" @click="goLimitVisitorsIP()">{{$t('im.commonChat.limitVisitorsIP')}}</el-button>
        </el-badge>
        <el-badge class="item">
          <el-button type="primary" @click="autoReplySetting()">{{autoReplyStatus?$t('im.commonChat.closeAutoReply'):$t('im.commonChat.enableAutoReply')}}</el-button>
        </el-badge>
      </div>
      <div class="layoutCon">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="itemCon" id="leftHeight">
                <div v-if="util.isNotEmpty(userID)" class="chatMasking"></div>
                <div class="nav">
                  <ul>
                    <li @click="clickTab(0)" :class="{'checked':navIndex==0}"><span>{{$t('im.commonChat.customerInfo')}}</span></li>
                    <li @click="clickTab(1)" :class="{'checked':navIndex==1}">
                      <el-dropdown @command="selectOften">
                        <span class="el-dropdown-link">{{oftenValue}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="item" v-for="item in oftenData">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </li>
                    <li @click="clickTab(2)" :class="{'checked':navIndex==2}"><span>{{$t('im.commonChat.historyChat')}}</span></li>
                  </ul>
                </div>
                <div class="navCon" v-if="navIndex==0" :style="{'minHeight':util.accDiv(height,1.31)+'px'}">
                  <div class="dv_list">
                    <ul :style="{'maxHeight':util.accDiv(height,1.45)+'px'}">
                      <li><span>{{$t('im.common.userID')}}：</span><p>{{customerInfo.customerId}}</p></li>
                      <li>
                        <span>{{$t('im.limitVisitorsIP.ip')}}：</span>
                        <p>{{customerInfo.userIp}}</p>
                        <img class="copyIP" @click="copyTxt(2,'.copyIP')" :data-clipboard-text="customerInfo.userIp" src="@/assets/IM/copy.png"/>
                      </li>
                      <li>
                        <span>{{$t('im.common.name')}}：</span>
                        <p v-if="isEdit">{{customerInfo.name}}</p>
                        <el-input v-else v-model="customerInfo.name" :disabled="isDisabled(sessionIds[userToken])" :placeholder="$t('im.common.placeholderName')"></el-input>
                      </li>
                      <li>
                        <span>{{$t('im.common.sex')}}：</span>
                        <p v-if="isEdit">{{customerInfo.sexName}}</p>
                        <el-select v-else v-model="customerInfo.sex" @change="changeSex" :placeholder="$t('im.common.placeholderSex')" :disabled="isDisabled(sessionIds[userToken])">
                          <el-option
                            v-for="item in sexData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </li>
                      <li>
                        <span>{{$t('im.common.telephone')}}：</span>
                        <p v-if="isEdit">{{customerInfo.phone}}</p>
                        <el-input v-else type='number' v-model="customerInfo.phone" :placeholder="$t('im.common.placeholderPhone')" :disabled="isDisabled(sessionIds[userToken])"></el-input>
                      </li>
                      <li>
                        <span>{{$t('im.common.qq')}}：</span>
                        <p v-if="isEdit">{{customerInfo.qq}}</p>
                        <el-input v-else type='number' v-model="customerInfo.qq" :placeholder="$t('im.common.placeholderQQ')" :disabled="isDisabled(sessionIds[userToken])"></el-input>
                      </li>
                      <li>
                        <span>{{$t('im.common.weChat')}}：</span>
                        <p v-if="isEdit">{{customerInfo.wechat}}</p>
                        <el-input v-else v-model="customerInfo.wechat" :placeholder="$t('im.common.placeholderWeChat')" :disabled="isDisabled(sessionIds[userToken])"></el-input>
                      </li>
                      <li>
                        <span>{{$t('im.common.email')}}：</span>
                        <p v-if="isEdit">{{customerInfo.email}}</p>
                        <el-input v-else v-model="customerInfo.email" :placeholder="$t('im.common.placeholderEmail')" :disabled="isDisabled(sessionIds[userToken])"></el-input>
                      </li>
                      <li><span>{{$t('im.common.locale')}}：</span><p>{{customerInfo.localeName}}</p></li>
                      <li><span>{{$t('im.common.userTypeName')}}：</span><p>{{customerInfo.userTypeName}}</p></li>
                      <li><span>{{$t('im.common.bizCodeName')}}：</span><p>{{customerInfo.bizCodeName}}</p></li>
                      <li><span>{{$t('im.common.tradePlatform')}}：</span><p>{{customerInfo.tradePlatform}}</p></li>
                      <li><span>{{$t('im.common.accountNum')}}：</span><p>{{customerInfo.userType==0?"":customerInfo.account}}</p></li>
                      <li><span>{{$t('im.common.accountStatus')}}：</span><p>{{util.isEmpty(customerInfo.activeStatus)?"":customerInfo.activeStatus==0?$t('im.common.inactivated'):$t('im.common.activated')}}</p></li>
                      <li><span>{{$t('im.common.activeTime')}}：</span><p>{{customerInfo.activeTime}}</p></li>
                      <li><span>{{$t('im.common.lastMoneyTime')}}：</span><p>{{customerInfo.lastMoneyTime}}</p></li>
                      <li><span>{{$t('im.common.tradeHandNum')}}：</span><p>{{customerInfo.tradeHandNum}}</p></li>
                      <li><span>{{$t('im.common.lastTradeTime')}}：</span><p>{{customerInfo.lastTradeTime}}</p></li>
                      <li><span>{{$t('im.common.accountChannel')}}：</span><p>{{customerInfo.accountChannel}}</p></li>
                      <li><span>{{$t('im.common.activityNum')}}：</span><p>{{customerInfo.activityNum}}</p></li>
                      <li>
                        <span>{{$t('im.common.ccFollow')}}：</span>
                        <p v-if="isEdit">{{customerInfo.ccFollow}}</p>
                        <el-input v-else v-model="customerInfo.ccFollow" :placeholder="$t('im.common.placeholderCC')" :disabled="isDisabled(sessionIds[userToken])"></el-input>
                      </li>
                      <li>
                        <span>{{$t('im.common.csFollow')}}：</span>
                        <p v-if="isEdit">{{customerInfo.csFollow}}</p>
                        <el-input v-else v-model="customerInfo.csFollow" :placeholder="$t('im.common.placeholderCS')" :disabled="isDisabled(sessionIds[userToken])"></el-input>
                      </li>
                      <li>
                        <span>{{$t('im.common.rmFollow')}}：</span>
                        <p v-if="isEdit">{{customerInfo.rmFollow}}</p>
                        <el-input v-else v-model="customerInfo.rmFollow" :placeholder="$t('im.common.placeholderRM')" :disabled="isDisabled(sessionIds[userToken])"></el-input>
                      </li>
                      <li>
                        <span>{{$t('im.common.chatTheme')}}：</span>
                        <p v-if="isEdit">{{chatThemeName}}</p>
                        <el-select v-else v-model="chatTheme" :placeholder="$t('im.common.placeholderChatTheme')" @change="changeTheme" :disabled="isDisabled(sessionIds[userToken])">
                          <el-option
                            v-for="item in chatThemeData"
                            :key="item.id"
                            :label="item.dictValue"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </li>
                      <li>
                        <span>{{$t('im.common.chatLevel')}}：</span>
                        <p v-if="isEdit">{{chatLevelName}}</p>
                        <el-select v-else v-model="chatLevel" :placeholder="$t('im.common.placeholderChatLevel')" @change="changeLevel" :disabled="isDisabled(sessionIds[userToken])">
                          <el-option
                            v-for="item in chatLevelData"
                            :key="item.id"
                            :label="item.dictValue"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </li>
                      <li>
                        <span>{{$t('im.common.remark')}}：</span>
                        <p v-if="isEdit">{{assessmentContent}}</p>
                        <el-input v-else v-model="assessmentContent" :disabled="isDisabled(sessionIds[userToken])" type="textarea" :rows="4" :placeholder="$t('im.common.placeholderRemark')" maxlength="100" show-word-limit></el-input>
                      </li>
                    </ul>
                  </div>
                  <div class="btn">
                    <el-button size="mini" @click="editUserInfo()">{{$t('im.bt.edit')}}</el-button>
                    <el-button type="primary" size="mini" @click="saveUserInfo()">{{$t('im.bt.save')}}</el-button>
                  </div>
                </div>
                <div class="navCon" v-if="navIndex==1" :style="{'minHeight':util.accDiv(height,1.31)+'px'}">
                  <el-tabs type="border-card" v-model="businessGroupCode" @tab-click="changeTab">
                    <el-tab-pane v-for="item in businessGroupData" :name="item.code">
                      <span slot="label">{{item.name}}</span>
                      <div class="searchCon">
                        <el-input v-model="searchKey" :placeholder="$t('im.common.placeholderKeywords')" @keyup.enter.native="searchCon"></el-input>
                        <el-button type="primary" size="medium"  @click="searchCon()">{{$t('im.bt.search')}}</el-button>
                      </div>
                      <el-form>
                        <el-form-item :label="$t('im.common.locale')" class="flexStart" v-if="langList&&langList.length>0">
                          <el-select v-model="langId" :placeholder="$t('im.common.placeholderLanguage')" @change="changeLang">
                            <el-option
                              v-for="item in langList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                      <div class="treeCon" :style="{'minHeight':util.accDiv(height,1.86)+'px','maxHeight':util.accDiv(height,1.86)+'px'}">
                        <el-collapse v-if="oftenTreeData&&oftenTreeData.length>0&&keyType==0" accordion>
                          <el-collapse-item :name="itemTree.id" v-for="itemTree in oftenTreeData" :disabled="isDisabled(itemTree.conCommonMessageVos)">
                            <template slot="title"><p>{{itemTree.name}}</p></template>
                            <div class="titleName"
                                 v-for="childItem in itemTree.conCommonMessageVos"
                                 :class="'cope_'+itemTree.id"
                                 @click="doubleClick(0,'.cope_'+itemTree.id,childItem,itemTree)"
                                 :data-clipboard-text="(util.isNotEmpty(childItem.message))?childItem.message:(oftenID==0||oftenID==1)?itemTree.name:childItem.name">
                              <el-tooltip effect="dark" :content="childItem.message" :disabled="isDisabled(childItem.message)" placement="right">
                                <el-button><p class="childName">{{childItem.name}}</p></el-button>
                              </el-tooltip>
                              <!--<p class="childName">{{childItem.name}}</p>
                              <div class="titleCon" v-if="childItem.message">
                                <em v-if="util.isNotEmpty(childItem.message)"></em>
                                <p>{{childItem.message}}</p>
                              </div>-->
                            </div>
                          </el-collapse-item>
                        </el-collapse>
                        <div v-if="keyType==1&&(oftenID==0||oftenID==1)" class="searchLayout">
                          <div class="item" v-for="item in oftenTreeBrushData"
                               :class="'cope_'+item.id"
                               @click="doubleClick(1,'.cope_'+item.id,item)"
                               :data-clipboard-text="item.message">
                            <el-tooltip effect="dark" :content="item.message" :disabled="isDisabled(item.message)" placement="right">
                              <el-button><p>{{item.name}}</p></el-button>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <div class="block flexEnd" v-if="totalNumTrees>0&&(oftenID==0||oftenID==1)">
                      <el-pagination
                        background
                        small
                        @current-change="currentChangeTrees"
                        :current-page="currentPageTrees"
                        :page-size="pageSizeTrees"
                        :pager-count="5"
                        layout="total, prev, pager, next, jumper"
                        :total="totalNumTrees">
                      </el-pagination>
                    </div>
                  </el-tabs>
                </div>
                <div class="navCon" v-if="navIndex==2" :style="{'minHeight':util.accDiv(height,1.31)+'px'}">
                  <el-table v-if="historyList&&height" :data="historyList" style="width: 100%" :height="util.accDiv(height,1.45)+'px'" @row-click="goChatDetailPop">
                    <el-table-column :prop="item.id" :label="item.name" v-for="item in historyNav" :show-overflow-tooltip="true"></el-table-column>
                  </el-table>
                  <div class="block flexEnd" v-if="totalNumHistorical>0">
                    <el-pagination
                      background
                      small
                      @current-change="currentChangeHistorical"
                      :current-page="currentPageHistorical"
                      :pager-count="5"
                      layout="total, prev, pager, next, jumper"
                      :total="totalNumHistorical">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <div class="itemCon">
                <div class="infoCon">
                  <ul>
                    <li><span>{{$t('im.common.address')}}</span><p>{{clientChatInfo.userAddress}}</p></li>
                    <li><span>{{$t('im.common.visitorsSource')}}</span><p>{{clientChatInfo.userSource}}</p></li>
                    <li>
                      <el-tooltip class="item" effect="dark"
                                  :disabled="isDisabled(clientChatInfo.lastAccessAddress)"
                                  placement="top">
                        <a slot="content" :href="clientChatInfo.lastAccessAddress" target="_blank">{{clientChatInfo.lastAccessAddress}}</a>
                        <el-button type="mini">{{$t('im.commonChat.sourceHref')}}</el-button>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
                <chatRoom ref="myChild"
                          :chatHeight="util.accDiv(height,1.3)+'px'"
                          :maxHeight="util.accSub((util.accDiv(height,1.3)),183)"
                          :clientChatInfo="clientChatInfo"
                          :service="4"
                          :userToken="userToken"
                          :chatType="chatType"
                ></chatRoom>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="itemCon">
              <div class="title"><span>{{$t('im.commonChat.chatList')}}</span></div>
              <div class="flexStart" v-if="chatType==1">
                <div v-if="util.isNotEmpty(userID)" class="chatMasking"></div>
                <el-button type="primary" size="mini" @click="endSession">{{$t('im.commonChat.chatEnd')}}</el-button>
                <el-button type="primary" size="mini" @click="getSendSession(clientChatInfo,0)">{{$t('im.commonChat.chatSend')}}</el-button>
              </div>
              <div class="table" :style="{'minHeight':chatType==1?util.accDiv(height,1.395)+ 'px':util.accDiv(height,1.3)+ 'px'}">
                <el-table ref="initTable"
                          style="width: 100%;"
                          :header-cell-style="{'background': '#eee'}"
                          :height="chatType==1?util.accDiv(height,1.395)+ 'px':util.accDiv(height,1.3)+ 'px'"
                          v-if="chatData&&height"
                          :data="chatData"
                          highlight-current-row
                          @current-change="getCurrentChange"
                          @row-click="getConnectSession"
                          @selection-change="selectionResource"
                >
                  <el-table-column v-if="chatType==1" type="selection" width="45"></el-table-column>
                  <el-table-column :label="$t('im.common.status')">
                    <template slot-scope="scope">
                      <p>{{scope.row.sessionStatusName}}</p>
                      <p class="bgColor" v-if="messageCount[scope.row.sessionId]>0">{{messageCount[scope.row.sessionId]}}</p>
                    </template>
                  </el-table-column>
                  <el-table-column :prop="item.id" :label="item.name" v-for="item in chatDataNav" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--待接入-->
      <el-dialog :title="$t('im.commonChat.waitAcceptInfo')" :visible.sync="isToAccessed" width="70%">
        <el-table v-if="WaitAcceptList&&height" :data="WaitAcceptList" style="width: 100%" border :max-height="util.accDiv(height,2)+ 'px'" :header-cell-style="{'background': '#eee'}">
          <el-table-column :prop="item.id" :label="item.name" v-for="item in WaitAcceptNav" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column :label="$t('im.bt.operator')">
            <template slot-scope="scope">
              <el-button size="mini" @click="accessChatList(scope.row)">{{$t('im.commonChat.accept')}}</el-button>
              <el-button size="mini" type="danger" @click="getSendSession(scope.row,1)">{{$t('im.commonChat.send')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flexCenter" v-if="WaitAcceptList&&WaitAcceptList.length>0">
          <el-button @click="allAccessChatList" size="mini">{{$t('im.commonChat.acceptAll')}}</el-button>
          <el-button type="primary" @click="isToAccessed = false" size="mini">{{$t('im.bt.cancel')}}</el-button>
        </div>
      </el-dialog>
      <!--待评估-->
      <el-dialog :title="$t('im.commonChat.waitEvaluatedInfo')" :visible.sync="isToAssessment" width="70%">
        <el-table v-if="evaluatedList&&height"
                  :data="evaluatedList"
                  :header-cell-style="{'background': '#eee'}"
                  style="width: 100%"
                  :max-height="util.accDiv(height,2)+'px'"
                  :row-class-name="tableRowClassName"
                  @row-click="goAssessmentSessionPop" border
        >
          <el-table-column :prop="item.id" :label="item.name" v-for="item in evaluatedNav" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <div class="block flexEnd" v-if="totalNumAssessment>0">
          <el-pagination
            background
            @size-change="pageSizeChangeAssessment"
            @current-change="currentChangeAssessment"
            :current-page="currentPageAssessment"
            :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNumAssessment">
          </el-pagination>
        </div>
      </el-dialog>
      <!--与某位客户进行评估-->
      <el-dialog :title="$t('im.commonChat.goEvaluated1')+evaluatedInfo.customerId+$t('im.commonChat.goEvaluated2')" :visible.sync="isToAssessmentSomeone" width="70%">
        <el-row :gutter="24">
          <el-col :span="10">
            <div class="title_tc"><span>{{$t('im.commonChat.chatRecord1')}}{{evaluatedInfo.customerId}}{{$t('im.commonChat.chatRecord2')}}</span></div>
            <div class="singleRecord boxShadow">
              <span>{{$t('im.commonChat.chatStart')}}：{{evaluatedInfo.startTime}}</span>
              <ul>
                <li v-for="item in chatRecord" :class="util.isNotEmpty(item.fromCustomerId)?'chat':'client'">
                  <p>{{item.fromName}}<em>({{item.createDate}})</em></p>
                  <span v-html="item.message"></span>
                  <span v-if="item.messageType==2&&util.isNotEmpty(item.previousQuestion)"><em>{{item.previousQuestion}}</em></span>
                  <span v-if="item.messageType==7">
                    {{item.locale=='zh_CN'?'对不起，'+item.fromName+'还不会这个问题，是否转人工服务？点这里转人工客服':item.locale=='en_US'?'Sorry，this question is difficult for '+item.fromName+' do you want to switch to Staff Service? Click here to switch':item.locale=='vi_VN'?'Xin lỗi，vấn đề này '+item.fromName+' không trả lời được, quý khách có muốn chuyển sang nhân viên CSKH không? Nhấn vào đây để chuyển':''}}
                  </span>
                  <span v-if="item.messageType==8">
                    {{item.locale=='zh_CN'?'对不起，这个问题难倒'+item.fromName+'了，是否给我们留言？点这里留言':item.locale=='en_US'?'Sorry，this question is difficult for '+item.fromName+' would you please leave us a messenger? Click here to leave':item.locale=='vi_VN'?'Xin lỗi，vấn đề này '+item.fromName+' không trả lời được, quý khách xin để lại lời dặn cho chúng tôi? >Nhấn vào Đây để viết lời dặn':''}}
                  </span>
                  <span v-if="(item.messageType==1||item.messageType==9)&&item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    {{item.locale=='zh_CN'?"您是否需要以下帮助？点击标题查看。":item.locale=='en_US'?"You may need those information? Please click the title to view details.":item.locale=='vi_VN'?"Chào bạn, bạn có cần những giúp đỡ bên dưới? Nhấn vào tiêu đề để tìm hiểu chi tiết.":""}}
                  </span>
                  <span v-if="item.messageType==2&&item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    {{item.locale=='zh_CN'?"相关问题：":item.locale=='en_US'?"Related Questions:":item.locale=='vi_VN'?"Vấn đề liên quan:":""}}
                  </span>
                  <ul v-if="item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    <li v-for="(intelligent,index) in item.conKnowledgeVos">
                      <span>{{index+1}}. {{intelligent.title}}</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <span>{{$t('im.commonChat.chatEnds')}}：{{evaluatedInfo.endTime}}</span>
              <span>{{evaluatedInfo.endReason==0?$t('im.commonChat.customerOff'):$t('im.commonChat.chatClose')}}</span>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="title_tc"><span>{{$t('im.commonChat.evaluatedInfo')}}</span></div>
            <div class="assessInfo">
              <ul>
                <li><span>{{$t('im.common.userID')}}：</span><p>{{evaluatedCustomerInfo.customerId}}</p></li>
                <li><span>{{$t('im.common.tradePlatform')}}：</span><p>{{evaluatedCustomerInfo.tradePlatform}}</p></li>
                <li><span>{{$t('im.common.userTypeName')}}：</span><p>{{evaluatedCustomerInfo.userTypeName}}</p></li>
                <li><span>{{$t('im.common.name')}}：</span><p>{{evaluatedCustomerInfo.name}}</p></li>
                <li><span>{{$t('im.common.accountNum')}}：</span><p>{{evaluatedCustomerInfo.account}}</p></li>
                <li><span>{{$t('im.common.sex')}}：</span><p>{{util.isEmpty(evaluatedCustomerInfo.sex)?"":evaluatedCustomerInfo.sex==0?$t('im.common.boy'):$t('im.common.girl')}}</p></li>
                <li><span>{{$t('im.common.accountStatus')}}：</span><p>{{util.isEmpty(evaluatedCustomerInfo.activeStatus)?"":evaluatedCustomerInfo.activeStatus==0?$t('im.common.inactivated'):$t('im.common.activated')}}</p></li>
                <li><span>{{$t('im.common.visitorsAddress')}}：</span><p>{{evaluatedCustomerInfo.userAddress}}</p></li>
                <li><span>{{$t('im.common.telephone')}}：</span><p>{{evaluatedCustomerInfo.phone}}</p></li>
                <li><span>{{$t('im.common.activeTime')}}：</span><p>{{evaluatedCustomerInfo.activeTime}}</p></li>
                <li><span>{{$t('im.common.userSource')}}：</span><p>{{evaluatedCustomerInfo.userSource}}</p></li>
                <li><span>{{$t('im.common.qq')}}：</span><p>{{evaluatedCustomerInfo.qq}}</p></li>
                <li><span>{{$t('im.common.lastTradeTime')}}：</span><p>{{evaluatedCustomerInfo.lastTradeTime}}</p></li>
                <li><span>{{$t('im.common.locale')}}：</span><p>{{evaluatedCustomerInfo.localeName}}</p></li>
                <li><span>{{$t('im.common.weChat')}}：</span><p>{{evaluatedCustomerInfo.wechat}}</p></li>
                <li><span>{{$t('im.common.tradeHandNum')}}：</span><p>{{evaluatedCustomerInfo.tradeHandNum}}</p></li>
                <li><span>{{$t('im.common.lastMoneyTime')}}：</span><p>{{evaluatedCustomerInfo.lastMoneyTime}}</p></li>
                <li><span>{{$t('im.common.email')}}：</span><p>{{evaluatedCustomerInfo.email}}</p></li>
                <li><span>{{$t('im.common.activityNum')}}：</span><p>{{evaluatedCustomerInfo.activityNum}}</p></li>
                <li><span>{{$t('im.common.ccFollow')}}：</span><p>{{evaluatedCustomerInfo.ccFollow}}</p></li>
                <li><span>{{$t('im.common.csFollow')}}：</span><p>{{evaluatedCustomerInfo.csFollow}}</p></li>
                <li><span>{{$t('im.common.rmFollow')}}：</span><p>{{evaluatedCustomerInfo.rmFollow}}</p></li>
                <li><span>{{$t('im.common.bizCodeName')}}：</span><p>{{evaluatedCustomerInfo.bizCodeName}}</p></li>
              </ul>
            </div>
            <el-form :inline="true">
              <el-form-item :label="$t('im.common.chatTheme')">
                <el-select v-model="chatThemeTc" :placeholder="$t('im.common.placeholderChatTheme')">
                  <el-option
                    v-for="item in chatThemeData"
                    :key="item.id"
                    :label="item.dictValue"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('im.common.chatLevel')">
                <el-select v-model="chatLevelTc" :placeholder="$t('im.common.placeholderChatLevel')">
                  <el-option
                    v-for="item in chatLevelData"
                    :key="item.id"
                    :label="item.dictValue"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="assessInfo">
              <ul>
                <li class="width">
                  <span>{{$t('im.common.remark')}}</span>
                  <el-input type="textarea" :rows="4" :placeholder="$t('im.common.placeholderRemark')" maxlength="100" show-word-limit v-model="evaluatedReason"></el-input>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <div class="flexCenter">
          <el-button type="primary" size="small" @click="saveAssessmentStatus">{{$t('im.bt.saveAndNext')}}</el-button>
          <el-button size="small" @click="nextAssessmentStatus">{{$t('im.bt.noAndNext')}}</el-button>
          <el-button size="small" @click="isToAssessmentSomeone=false">{{$t('im.bt.cancel')}}</el-button>
        </div>
      </el-dialog>
      <!--接受对话信息-->
      <el-dialog :title="$t('im.commonChat.acceptSessionInfo')" :visible.sync="isToAcceptChatInfoList" width="70%">
        <el-table v-if="acceptChatList&&height" :data="acceptChatList" style="width: 100%" border :max-height="util.accDiv(height,2)+'px'" :header-cell-style="{'background': '#eee'}">
          <el-table-column :prop="item.id" :label="item.name" v-for="item in acceptChatNav" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column :label="$t('im.bt.operator')">
            <template slot-scope="scope">
              <el-button size="mini" @click="acceptChatSession(scope.row)">{{$t('im.commonChat.reception')}}</el-button>
              <el-button size="mini" type="danger" @click="rejectChatSession(scope.row)">{{$t('im.commonChat.refusal')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--传送对话信息-->
      <el-dialog :title="$t('im.commonChat.chatSendInfo')" :visible.sync="isToSendChatInfo" :before-close="cancelSendSession">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="chatTit_tc"><span>{{$t('im.commonChat.sender')}}:</span></div>
            <div class="chatCon_tc"><p>{{userInfo.displayName}}</p></div>
          </el-col>
          <el-col :span="6">
            <div class="chatTit_tc"><span>{{$t('im.commonChat.receiver')}}:</span></div>
            <div class="chatCon_tc">
              <el-radio v-model="sendRadio" :label="item" v-for="item in OnlineChatList" @change="changeSendSession">{{item.name}}</el-radio>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="chatTit_tc"><span>{{$t('im.commonChat.chatSend')}}</span></div>
            <div class="chatCon_tc"><p>{{$t('im.commonChat.chatID')}}:{{clientChatInfo.sessionId}}</p></div>
          </el-col>
          <el-col :span="6">
            <div class="chatTit_tc"><span>{{$t('im.commonChat.sendReason')}}</span></div>
            <div class="chatCon_tc">
              <el-input
                type="textarea"
                :rows="4"
                :placeholder="$t('im.commonChat.placeholderSendReason')"
                v-model="sendReason">
              </el-input>
            </div>
          </el-col>
        </el-row>
        <div class="flexCenter">
          <el-button type="primary" size="small" @click="saveSendSession">{{$t('im.bt.definite')}}</el-button>
          <el-button size="small" @click="cancelSendSession">{{$t('im.bt.cancel')}}</el-button>
        </div>
      </el-dialog>
      <!--历史会话详情-->
      <el-dialog :title="$t('im.commonChat.chatInfo')" :visible.sync="isToChatDetailPop" width="70%">
        <div class="padding scrollY" :style="{'max-height':util.accSub((util.accDiv(height,1.3)),190)+'px'}">
          <div class="padding">
            <div class="title_tc"><span>{{$t('im.commonChat.customerInfo')}}</span></div>
            <div class="assessInfo">
              <ul>
                <li><span>{{$t('im.common.userID')}}：</span><p>{{historyCustomerInfo.customerId}}</p></li>
                <li><span>{{$t('im.common.tradePlatform')}}：</span><p>{{historyCustomerInfo.tradePlatform}}</p></li>
                <li><span>{{$t('im.common.userTypeName')}}：</span><p>{{historyCustomerInfo.userTypeName}}</p></li>
                <li><span>{{$t('im.common.name')}}：</span><p>{{historyCustomerInfo.name}}</p></li>
                <li><span>{{$t('im.common.accountNum')}}：</span><p>{{historyCustomerInfo.account}}</p></li>
                <li><span>{{$t('im.common.sex')}}：</span><p>{{util.isEmpty(historyCustomerInfo.sex)?"":historyCustomerInfo.sex==0?$t('im.common.boy'):$t('im.common.girl')}}</p></li>
                <li><span>{{$t('im.common.accountStatus')}}：</span><p>{{util.isEmpty(historyCustomerInfo.activeStatus)?"":historyCustomerInfo.activeStatus==0?$t('im.common.inactivated'):$t('im.common.activated')}}</p></li>
                <li><span>{{$t('im.common.visitorsAddress')}}：</span><p>{{historyCustomerInfo.userAddress}}</p></li>
                <li><span>{{$t('im.common.telephone')}}：</span><p>{{historyCustomerInfo.phone}}</p></li>
                <li><span>{{$t('im.common.activeTime')}}：</span><p>{{historyCustomerInfo.activeTime}}</p></li>
                <li><span>{{$t('im.common.userSource')}}：</span><p>{{historyCustomerInfo.userSource}}</p></li>
                <li><span>{{$t('im.common.qq')}}：</span><p>{{historyCustomerInfo.qq}}</p></li>
                <li><span>{{$t('im.common.lastTradeTime')}}：</span><p>{{historyCustomerInfo.lastTradeTime}}</p></li>
                <li><span>{{$t('im.common.locale')}}：</span><p>{{historyCustomerInfo.localeName}}</p></li>
                <li><span>{{$t('im.common.weChat')}}：</span><p>{{historyCustomerInfo.wechat}}</p></li>
                <li><span>{{$t('im.common.tradeHandNum')}}：</span><p>{{historyCustomerInfo.tradeHandNum}}</p></li>
                <li><span>{{$t('im.common.lastMoneyTime')}}：</span><p>{{historyCustomerInfo.lastMoneyTime}}</p></li>
                <li><span>{{$t('im.common.email')}}：</span><p>{{historyCustomerInfo.email}}</p></li>
                <li><span>{{$t('im.common.activityNum')}}：</span><p>{{historyCustomerInfo.activityNum}}</p></li>
                <li><span>{{$t('im.common.ccFollow')}}：</span><p>{{historyCustomerInfo.ccFollow}}</p></li>
                <li><span>{{$t('im.common.csFollow')}}：</span><p>{{historyCustomerInfo.csFollow}}</p></li>
                <li><span>{{$t('im.common.rmFollow')}}：</span><p>{{historyCustomerInfo.rmFollow}}</p></li>
                <li><span>{{$t('im.common.bizCodeName')}}：</span><p>{{historyCustomerInfo.bizCodeName}}</p></li>
              </ul>
            </div>
          </div>
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="title_tc"><span>{{$t('im.commonChat.chatRecord1')}}{{historyChatDetailInfo.customerId}}{{$t('im.commonChat.chatRecord2')}}</span></div>
              <div class="singleRecord boxShadow">
                <span>{{$t('im.commonChat.chatStart')}}：{{historyChatDetailInfo.startTime}}</span>
                <ul>
                  <li v-for="item in chatRecord" :class="util.isNotEmpty(item.fromCustomerId)?'chat':'client'">
                    <p>{{item.fromName}}<em>({{item.createDate}})</em></p>
                    <span v-html="item.message"></span>
                    <span v-if="item.messageType==2&&util.isNotEmpty(item.previousQuestion)"><em>{{item.previousQuestion}}</em></span>
                    <span v-if="item.messageType==7">
                    {{item.locale=='zh_CN'?'对不起，'+item.fromName+'还不会这个问题，是否转人工服务？点这里转人工客服':item.locale=='en_US'?'Sorry，this question is difficult for '+item.fromName+' do you want to switch to Staff Service? Click here to switch':item.locale=='vi_VN'?'Xin lỗi，vấn đề này '+item.fromName+' không trả lời được, quý khách có muốn chuyển sang nhân viên CSKH không? Nhấn vào đây để chuyển':''}}
                  </span>
                    <span v-if="item.messageType==8">
                    {{item.locale=='zh_CN'?'对不起，这个问题难倒'+item.fromName+'了，是否给我们留言？点这里留言':item.locale=='en_US'?'Sorry，this question is difficult for '+item.fromName+' would you please leave us a messenger? Click here to leave':item.locale=='vi_VN'?'Xin lỗi，vấn đề này '+item.fromName+' không trả lời được, quý khách xin để lại lời dặn cho chúng tôi? >Nhấn vào Đây để viết lời dặn':''}}
                  </span>
                    <span v-if="(item.messageType==1||item.messageType==9)&&item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    {{item.locale=='zh_CN'?"您是否需要以下帮助？点击标题查看。":item.locale=='en_US'?"You may need those information? Please click the title to view details.":item.locale=='vi_VN'?"Chào bạn, bạn có cần những giúp đỡ bên dưới? Nhấn vào tiêu đề để tìm hiểu chi tiết.":""}}
                  </span>
                    <span v-if="item.messageType==2&&item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    {{item.locale=='zh_CN'?"相关问题：":item.locale=='en_US'?"Related Questions:":item.locale=='vi_VN'?"Vấn đề liên quan:":""}}
                  </span>
                    <ul v-if="item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                      <li v-for="(intelligent,index) in item.conKnowledgeVos">
                        <span>{{index+1}}. {{intelligent.title}}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
                <span>{{$t('im.commonChat.chatEnds')}}：{{historyChatDetailInfo.endTime}}</span>
                <span>{{historyChatDetailInfo.endReason==0?$t('im.commonChat.customerOff'):$t('im.commonChat.chatClose')}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="title_tc"><span>{{$t('im.commonChat.evaluatedInfo')}}</span></div>
              <div class="dv_list boxShadow">
                <ul>
                  <li><span>{{$t('im.common.startTime')}}：</span><p>{{historyChatDetailInfo.startTime}}</p></li>
                  <li><span>{{$t('im.common.endTime')}}：</span><p>{{historyChatDetailInfo.endTime}}</p></li>
                  <li><span>{{$t('im.common.sessionTime')}}：</span><p>{{historyChatDetailInfo.sessionTime}}</p></li>
                  <li><span>{{$t('im.common.visitorsID')}}：</span><p>{{historyChatDetailInfo.customerId}}</p></li>
                  <li><span>{{$t('im.common.serviceName')}}：</span><p>{{historyChatDetailInfo.serviceName}}</p></li>
                  <li><span>{{$t('im.common.visitorsIp')}}：</span><p>{{historyChatDetailInfo.userIp}}</p></li>
                  <li><span>{{$t('im.common.visitorsAddress')}}：</span><p>{{historyChatDetailInfo.userAddress}}</p></li>
                  <li><span>{{$t('im.common.visitorsWay')}}：</span><p>{{historyChatDetailInfo.clientName}}</p></li>
                  <li>
                    <span>{{$t('im.common.chatTheme')}}：</span>
                    <el-select v-model="chatThemeHistoricalTc" :placeholder="$t('im.common.placeholderChatTheme')">
                      <el-option
                        v-for="item in chatThemeData"
                        :key="item.id"
                        :label="item.dictValue"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </li>
                  <li>
                    <span>{{$t('im.common.chatLevel')}}：</span>
                    <el-select v-model="chatLevelHistoricalTc" :placeholder="$t('im.common.placeholderChatLevel')">
                      <el-option
                        v-for="item in chatLevelData"
                        :key="item.id"
                        :label="item.dictValue"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </li>
                  <li>
                    <span>{{$t('im.common.remark')}}</span>
                    <el-input type="textarea" :rows="4" :placeholder="$t('im.common.placeholderRemark')" maxlength="100" show-word-limit v-model="historyChatDetailReason"></el-input>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="flexCenter">
          <el-button type="primary" size="small" @click="saveUserAccess">{{$t('im.bt.save')}}</el-button>
          <el-button size="small" @click="isToChatDetailPop=false">{{$t('im.bt.cancel')}}</el-button>
        </div>
      </el-dialog>
      <!--监控客服-->
      <el-dialog :title="$t('im.commonChat.checkChatMonitor')" :visible.sync="isChatMonitor" width="30%">
        <div class="chatMonitor">
          <ul v-if="chatMonitorData&&chatMonitorData.length>0">
            <li v-for="item in chatMonitorData">
              <p>{{item.displayName}}</p>
              <a @click="addChatMonitor(item)">{{$t('im.commonChat.chatMonitor')}}</a>
            </li>
          </ul>
          <ul v-else><span>{{$t('im.commonChat.noData')}}</span></ul>
        </div>
      </el-dialog>
      <!--访客IP限制设置-->
      <el-dialog :title="$t('im.commonChat.limitVisitorsIP')" :visible.sync="isLimitVisitorsIP">
        <el-form class="div_form" label-width="100px">
          <el-form-item :label="$t('im.limitVisitorsIP.limitType')">
            <el-radio v-model="radioTxt" label="0" @change="visitorsIPType">{{$t('im.limitVisitorsIP.ip')}}</el-radio>
            <el-radio v-model="radioTxt" label="1" @change="visitorsIPType">{{$t('im.limitVisitorsIP.account')}}</el-radio>
          </el-form-item>
          <el-form-item :label="$t('im.limitVisitorsIP.limitTypeCon')">
            <!--<p>{{radioContent}}</p>-->
            <el-input v-model="radioContent" disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item :label="$t('im.limitVisitorsIP.limitReason')">
            <el-input type="textarea" :rows="2" v-model="contentTxt"></el-input>
          </el-form-item>
        </el-form>
        <div class="flexCenter">
          <el-button type="primary" @click="submitSave">{{$t('im.bt.definite')}}</el-button>
          <el-button @click="isLimitVisitorsIP=false">{{$t('im.bt.cancel')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  require('@/styles/IM/template.css')
  require('@/styles/IM/chatSystem.css')
  import Textarea from '@/views/IM/model/textarea.vue'
  import chatRoom from '@/views/IM/model/chatRoom.vue'
  import apiChatSystem from '@/api/im/chatSystem'
  import apiDeployManagement from '@/api/im/deployManagement'
  import Util from '@/utils/IM/tradeDataUtil'
  import { localRead } from '@/utils/tools'
  import imStore from '@/store/modules/im'
  import Clipboard from 'clipboard'

  export default {
    name: 'commonChat',
    components: { Textarea, chatRoom},
    props: ['chatType'],
    data() {
      return {
        util: Util,
        height: '',
        navIndex: 0,
        userTypeData: [
          { name: window.$t('im.common.traveler'), id: 0 },
          { name: window.$t('im.common.demo'), id: 1 },
          { name: window.$t('im.common.inactivated'), id: 2 },
          { name: window.$t('im.common.activated'), id: 3 }
        ],//用户类型
        sexData: [
          { name: window.$t('im.common.boy'), id: 0 },
          { name: window.$t('im.common.girl'), id: 1 }
        ],//性别
        chatLevel: '',
        chatLevelName: '',
        chatLevelTc: '',
        chatLevelHistoricalTc: '',
        chatLevelData: [],//对话级别
        chatTheme: '',
        chatThemeName: '',
        chatThemeTc: '',
        chatThemeHistoricalTc: '',
        chatThemeData: [],//对话主题
        assessmentContent: '',//客户信息备注
        searchKey: '',//搜索关键字
        keyType: 0,//是否为关键字搜索0：否，1：是
        oftenValue: window.$t('im.commonChat.commonWords'),
        oftenID: 0,
        oftenData: [
          {
            id: '0',
            name: window.$t('im.commonChat.commonWords')
          }, {
            id: '1',
            name: window.$t('im.commonChat.personalWords')
          }, {
            id: '2',
            name: window.$t('im.commonChat.commonHref')
          }, {
            id: '3',
            name: window.$t('im.commonChat.commonImg')
          }, {
            id: '4',
            name: window.$t('im.commonChat.commonFile')
          }
        ],
        oftenTreeData: [],//常用语树
        oftenTreeBrushData: [],//常用语树刷选数据
        commonWordsTrees: '',//常用语树列表
        currentPageTrees:1,//常用语树当前页数
        pageSizeTrees:10, //常用语树当前页条数数
        totalNumTrees:0,//常用语树当前资源条数
        isOften: 0,//是否常用语
        historyList: [],//历史会话列表数据或待评估列表
        historyNav: [
          { name: window.$t('im.common.chatTheme'), id: 'sessionTopicName' },
          { name: window.$t('im.common.chatLevel'), id: 'sessionLevelName' },
          { name: window.$t('im.common.startTime'), id: 'startTime' },
          { name: window.$t('im.common.endTime'), id: 'endTime' },
          { name: window.$t('im.common.userIp'), id: 'userIp' },
          { name: window.$t('im.common.address'), id: 'userAddress' },
          { name: window.$t('im.common.userSource'), id: 'userSource' },
          { name: window.$t('im.common.sessionTime'), id: 'sessionTime' },
          { name: window.$t('im.common.serviceName'), id: 'serviceName' }
        ],//历史会话列表标题
        currentPageHistorical: 1,  //历史会话当前页数
        totalNumHistorical: 0,  //历史会话当前资源条数
        isToChatDetailPop: false,//是否展示客户详细信息弹窗
        historyChatDetailInfo: '',//历史会话详细信息
        historyCustomerInfo: '',//历史会话客户信息
        historyChatDetailReason: '',//历史会话备注
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCode: '',  //常用语业务编码Code
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        langId: 'zh_CN',  //默认显示语言的ID
        chatDataNav: [
          // { name: '状态', id: 'sessionStatusName' },
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.common.visitorsID'), id: 'customerId' },
          { name: window.$t('im.common.visitorsName'), id: 'name' },
          { name: window.$t('im.common.accountNum'), id: 'account' },
          { name: window.$t('im.common.visitorsSource'), id: 'userSource' },
          { name: window.$t('im.common.startTime'), id: 'startTime' },
          { name: window.$t('im.common.visitorsIp'), id: 'userIp' },
          { name: window.$t('im.common.address'), id: 'userAddress' },
          { name: window.$t('im.common.replyTime'), id: 'replyTime' },
          { name: window.$t('im.common.serviceName'), id: 'serviceName' },
          { name: window.$t('im.common.lastAccessAddress'), id: 'lastAccessAddress' },
          { name: window.$t('im.common.locale'), id: 'localeName' },
          { name: window.$t('im.common.visitorsWay'), id: 'clientName' },
          { name: window.$t('im.commonChat.chatID'), id: 'sessionId' },
          { name: window.$t('im.common.clientDetail'), id: 'clientDetail' }
        ],//会话列表标题
        clientChatInfo: '',//客户会话信息
        isEdit: true,//是否编辑
        customerInfo: '',//客户信息
        isFirst: true,//是否第一次进页面或刷新页面
        isToAccessed: false,//是否展示待接入弹窗
        WaitAcceptList: '',//待接入会话列表
        WaitAcceptNav: [
          { name: window.$t('im.common.visitorsID'), id: 'customerId' },
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.common.startTime'), id: 'startTime' }
        ],//待接入会话列表标题
        isToSendChatInfo: false,//是否展示传送对话信息
        sendType: 0,//是否直接传送
        sendRadio: '',//选择传送人
        sendReason: '',//传送原因和当前客服信息
        OnlineChatList: [],//在线客服列表
        currentRow: null,
        multipleSelection: [],  //选择条数集合
        isToAssessment: false,//是否展示待评估信息
        isToAcceptChatInfoList: false,//是否展示接受对话信息列表
        acceptChatList: [],//接受对话列表
        acceptChatNav: [
          { name: window.$t('im.commonChat.sender'), id: 'serviceName' },
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.commonChat.chatID'), id: 'sessionId' },
          { name: window.$t('im.commonChat.sendReason'), id: 'transferReason' }
        ],//接受对话列表标题
        isToAssessmentSomeone: false,//是否展示具体待评估信息
        currentPageAssessment: 1,  //待评估当前页数
        pageSizeAssessment: 10, //待评估当前页条数数
        totalNumAssessment: 0,  //待评估当前资源条数
        evaluatedList: [],//待评估列表
        evaluatedNav: [
          { name: window.$t('im.common.visitorsID'), id: 'customerId' },
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.common.startTime'), id: 'startTime' },
          { name: window.$t('im.commonChat.endReason'), id: 'endReasonName' }
        ],//待评估列表标题
        evaluatedInfo: '',//待评估个人信息
        evaluatedCustomerInfo: '',//待评估客户信息
        chatRecord: [],//聊天记录
        evaluatedReason: '',//客户进行评估的备注
        clientTypeData: [
          { name: window.$t('im.common.mobile'), id: 0 },
          { name: window.$t('im.common.pc'), id: 1 },
          { name: window.$t('im.common.app'), id: 2 }
        ],//访客方式
        isChatMonitor: false,//是否展示监控客服弹窗
        chatMonitorData: [],//监控客服列表
        userID: this.$route.query.id || '',//监控客服ID
        userToken: Util.isEmpty(this.$route.query.id) ? JSON.parse(localRead('sys_userInfo_IM')).userToken : this.$route.query.id,//客服userToken
        sessionIdArtificial: this.$route.query.sessionId,//人工介入sessionId
        clickTimes: 0,
        isLimitVisitorsIP:false,//是否显示访客IP限制弹窗
        radioTxt: '0',   //选择IP或账户
        radioContent: '',  //IP或账户内容
        contentTxt: '',  //阻止原因
        evaluatedIndex:"",//评估信息的索引
        autoReplyStatus: false,
      }
    },
    computed: {
      serviceMarks: {
        get() {
          return this.$store.state.im.serviceMark
        }
      },
      /*人工客服未读消息数量*/
      messageCount: {
        get() {
          return this.$store.state.im.messageNums
        }
      },
      chatData: {//会话列表数据
        get() {
          let data
          if (this.chatType == 0) {
            data = this.$store.state.im.intelligentChatList
          }
          if (this.chatType == 1) {
            data = this.$store.state.im.chatList
          }
          return data
        }
      },
      commonWordsList: {
        get() {
          if (Util.isNotEmpty(this.searchKey)) {
            return this.commonWordsTrees.filter((value) => {
              console.log(!isNaN(this.searchKey))
              if (!isNaN(this.searchKey)) {
                if (String(value.name).indexOf(this.searchKey) > -1) return String(value.name).indexOf(this.searchKey) > -1
                if (String(value.name).indexOf(this.searchKey) <= -1) {
                  if (String(value.address).indexOf(this.searchKey) > -1 || String(value.address).indexOf(this.searchKey) > -1) {
                    return value
                  }
                  for (const i in value.conCommonMessageVos) {
                    if (String(value.conCommonMessageVos[i].name).indexOf(this.searchKey) > -1 || String(value.conCommonMessageVos[i].message).indexOf(this.searchKey) > -1) {
                      return value
                    }
                  }
                }
              } else {
                if (String(value.name).indexOf(this.searchKey) > -1) return String(value.name).indexOf(this.searchKey) > -1
                if (String(value.name).indexOf(this.searchKey) <= -1) {
                  if (String(value.address).indexOf(this.searchKey) > -1 || String(value.address).indexOf(this.searchKey) > -1) {
                    return value
                  }
                  for (const i in value.conCommonMessageVos) {
                    if (String(value.conCommonMessageVos[i].name).indexOf(this.searchKey) > -1 || String(value.conCommonMessageVos[i].message).indexOf(this.searchKey) > -1) {
                      return value
                    }
                  }
                }
              }
            })
          } else {
            return this.commonWordsTrees
          }
        }
      },
      sessionIds: {
        get() {
          return this.$store.state.im.sessionId
        }
      },
      intelligentSessionIds: {
        get() {
          return this.$store.state.im.intelligentSessionId
        }
      },
      sessionStatus: {
        get() {
          return this.$store.state.im.sessionStatus
        }
      },
      acceptSessionIds: {
        get() {
          return this.$store.state.im.acceptSessionId
        }
      },
      serviceStatusInfo: {
        get() {
          return this.$store.state.im.serviceStatus
        }
      },
      monitorSessionIds: {
        get() {
          return this.$store.state.im.monitorSessionId
        }
      }
    },
    methods: {
      docHeight() {
        let clientHeight = (window.innerHeight || document.documentElement.clientHeight) - 7
        if (this.chatType == 1) {
          this.height = clientHeight
        } else if (this.chatType == 0) {
          this.height = clientHeight * 1.075
        }
      },
      /*tab切换*/
      clickTab(index) {
        this.searchKey = ''
        this.navIndex = index
        if (index == 1) {
          this.keyType = 0
          if (this.oftenID == 0) {
            this.initCommonMessageVoTrees(0)
          } else if (this.oftenID == 1) {
            this.initCommonMessageVoTrees(1, this.userInfo.userName)
          } else if (this.oftenID == 2) {
            this.initResourceLis(0)
          } else if (this.oftenID == 3) {
            this.initResourceLis(1)
          } else if (this.oftenID == 4) {
            this.initResourceLis(2)
          }
        }
      },
      /*初始化用户信息*/
      initUserInfo(type, userToken) {//0：接受聊天，1：具体会话待评估信息,2:历史会话详情
        if (Util.isNotEmpty(userToken)) {
          let data = {
            userToken: userToken
          }
          apiChatSystem.queryBizUserVo(data).then(res => {
            if (res.code == 0) {
              if (res.result) {
                let newData = JSON.parse(JSON.stringify(res.result))
                this.brushUserType(newData)
                this.brushClientType(newData)
                this.brushBusinessGroup(newData)
                this.brushLocale(newData)
                this.brushSex(newData)
                if (newData.userType == 0) newData.account = ''
                if (type == 0) {
                  this.customerInfo = newData
                } else if (type == 1) {
                  this.evaluatedCustomerInfo = newData
                } else if (type == 2) this.historyCustomerInfo = newData
              } else {
                if (type == 0) {
                  this.customerInfo = ''
                } else if (type == 1) {
                  this.evaluatedCustomerInfo = ''
                } else if (type == 2) this.historyCustomerInfo = ''
              }
            }
          })
        } else {
          if (type == 0) {
            this.customerInfo = ''
          } else if (type == 1) {
            this.evaluatedCustomerInfo = ''
          } else if (type == 2) this.historyCustomerInfo = ''
        }
      },
      /*初始化主题、级别*/
      initChatList(type) {
        let data = {
          companyId: this.userInfo.companyId,
          dictType: type,
          pageNum: this.currentPage
        }
        apiDeployManagement.queryConAccessDictList(data).then(res => {
          if (res.code == 0) {
            if (type == 0) {
              if (res.result) {
                this.chatThemeData = res.result
              } else {
                this.chatThemeData = []
              }
            } else if (type == 1) {
              if (res.result) {
                this.chatLevelData = res.result
              } else {
                this.chatLevelData = []
              }
            }
          }
        })
      },
      /*用户信息选择性别*/
      changeSex(id) {
        for (const i in this.sexData) {
          if (this.sexData[i].id == id) this.customerInfo.sexName = this.sexData[i].name
        }
      },
      /*用户信息选择对话主题*/
      changeTheme(id) {
        for (const i in this.chatThemeData) {
          if (this.chatThemeData[i].id == id) this.chatThemeName = this.chatThemeData[i].dictValue
        }
      },
      /*用户信息选择对话级别*/
      changeLevel(id) {
        for (const i in this.chatLevelData) {
          if (this.chatLevelData[i].id == id) this.chatLevelName = this.chatLevelData[i].dictValue
        }
      },
      //编辑用户信息
      editUserInfo() {
        if (Util.isNotEmpty(this.customerInfo.id)) {
          this.isEdit = false
        } else {
          this.$message(window.$t('im.commonChat.checkChat'))
        }
      },
      /*保存客服评估*/
      saveUserInfo() {
        if (Util.isNotEmpty(this.customerInfo.id)) {
          if (this.isEdit) {
            this.$message(window.$t('im.commonChat.notEdit'))
          } else {
            let data = {
              'serviceToken': this.userInfo.userToken,
              'id': this.customerInfo.id,
              'ccFollow': this.customerInfo.ccFollow,
              'csFollow': this.customerInfo.csFollow,
              'rmFollow': this.customerInfo.rmFollow,
              'email': this.customerInfo.email,
              'name': this.customerInfo.name,
              'phone': this.customerInfo.phone,
              'qq': this.customerInfo.qq,
              'sex': this.customerInfo.sex,
              'wechat': this.customerInfo.wechat,
              'sessionLevel': this.chatLevel,
              'sessionTopic': this.chatTheme,
              'assessmentContent': this.assessmentContent,
              'sessionId': this.clientChatInfo.sessionId,
              'operator': this.userInfo.id,
              'operatorName': this.userInfo.displayName
            }
            apiChatSystem.serviceUpdateUser(data).then(res => {
              if (res.code == 0 && res.result == true) {
                this.$message.success(window.$t('im.commonChat.updateSuc'))
                this.isEdit = true
              } else {
                this.$message.error(window.$t('im.commonChat.updateFail'))
              }
            })
          }
        } else {
          this.$message(window.$t('im.commonChat.checkChat'))
        }
      },
      doubleClick(type, val, obj, parentObj) {
        this.clickTimes++
        if (this.clickTimes === 2) { //当点击次数为2
          this.clickTimes = 0 //记得清零
          this.copyTxt(type, val, obj, parentObj)
        }
        setTimeout(() => {
          if (this.clickTimes === 1) {
            this.clickTimes = 0
          }
        }, 250)
      },
      /*复制常用语*/
      copyTxt(type, val, obj, parentObj) {
        let clipboard = new Clipboard(val)
        clipboard.on('success', e => {
          // this.$message('复制成功')
          let copyContentTxt = '';
          if (type == 2) {
            this.$message('复制成功')
          } else {
            if (type == 0) {
              copyContentTxt = (Util.isNotEmpty(obj.message)) ? obj.message : (this.oftenID == 0 || this.oftenID == 1) ? parentObj.name : obj.name
            } else if (type == 1) {
              copyContentTxt = obj.message
            }
            this.$refs.myChild.copyContent(copyContentTxt, 0)
          }
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          this.$message(window.$t('im.commonChat.notCopy'))
          clipboard.destroy()
        })
      },
      /*初始化业务组tab*/
      initTcBusinessGroup() {
        if (this.businessGroupData.length > 0) {
          this.businessGroupCode = this.businessGroupData[0].code
        }
      },
      /*业务组tab*/
      changeTab(tab) {
        this.businessGroupCode = tab.name
        if (this.oftenID == 0) {
          this.initCommonMessageVoTrees(0)
        } else if (this.oftenID == 1) {
          this.initCommonMessageVoTrees(1, this.userInfo.userName)
        }else this.brushTree(this.commonWordsList)
      },
      /*查询关键词*/
      searchCon() {
        if (Util.isEmpty(this.searchKey)) {
          this.keyType = 0
          if (this.navIndex == 1) {
            if (this.oftenID == 0) {
              this.initCommonMessageVoTrees(0)
            } else if (this.oftenID == 1) {
              this.initCommonMessageVoTrees(1, this.userInfo.userName)
            } else if (this.oftenID == 2) {
              this.initResourceLis(0)
            } else if (this.oftenID == 3) {
              this.initResourceLis(1)
            } else if (this.oftenID == 4) {
              this.initResourceLis(2)
            }
          }
        } else if (this.searchKey.length < 2 && Util.isNotEmpty(this.searchKey)) {
          this.$message.info(window.$t('im.commonChat.length'))
        } else {
          this.keyType = 1
          if (this.oftenID == 0) {
            this.currentPageTrees = 1
            this.pageSizeTrees = 100
            this.searchCommonMessageVoTrees(0)
          } else if (this.oftenID == 1) {
            this.currentPageTrees = 1
            this.pageSizeTrees = 100
            this.searchCommonMessageVoTrees(1, this.userInfo.userName)
          } else {
            this.keyType = 0
            this.brushTree(this.commonWordsList)
          }
        }
      },
      /*选择弹窗语言*/
      changeLang() {
        if (Util.isEmpty(this.searchKey)){
          this.keyType = 0
          if (this.navIndex == 1) {
            if (this.oftenID == 0) {
              this.initCommonMessageVoTrees(0)
            } else if (this.oftenID == 1) {
              this.initCommonMessageVoTrees(1, this.userInfo.userName)
            } else if (this.oftenID == 2) {
              this.initResourceLis(0)
            } else if (this.oftenID == 3) {
              this.initResourceLis(1)
            } else if (this.oftenID == 4) {
              this.initResourceLis(2)
            }
          }
        }else {
          this.keyType = 1
          if (this.oftenID == 0) {
            this.searchCommonMessageVoTrees(0)
          } else if (this.oftenID == 1) {
            this.searchCommonMessageVoTrees(1, this.userInfo.userName)
          } else {
            this.keyType = 0
            this.brushTree(this.commonWordsList)
          }
        }
      },
      /*常用选择*/
      selectOften(obj) {
        this.searchKey = ''
        this.keyType = 0
        this.oftenID = obj.id
        this.oftenValue = obj.name
        if (obj.id == 0) {
          this.initCommonMessageVoTrees(0)
        } else if (obj.id == 1) {
          this.initCommonMessageVoTrees(1, this.userInfo.userName)
        } else if (obj.id == 2) {
          this.initResourceLis(0)
        } else if (obj.id == 3) {
          this.initResourceLis(1)
        } else if (obj.id == 4) {
          this.initResourceLis(2)
        }
      },
      /*刷选公共常用语树*/
      brushTree(data) {
        let newData = []
        let oldData = JSON.parse(JSON.stringify(data))
        for (const i in oldData) {
          if (oldData[i].bizCode == this.businessGroupCode && oldData[i].locale == this.langId) {
            if (this.isOften == 0) {
              newData.push(oldData[i])
            } else if (this.isOften == 1) {
              let obj = JSON.parse(JSON.stringify(data[i]))
              oldData[i].conCommonMessageVos = [obj]
              oldData[i].conCommonMessageVos[0].name = obj.address
              newData.push(oldData[i])
            }
          }
        }
        this.oftenTreeData = newData
      },
      /*初始化公共常用语树形*/
      initCommonMessageVoTrees(messageType, username) {
        this.currentPageTrees = 1
        this.pageSizeTrees = 10
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          pageNum: this.currentPageTrees,
          pageSize: this.pageSizeTrees,
          messageType: messageType,
          username: username
        }
        this.getCommonMessageVoTrees(data)
      },
      getCommonMessageVoTrees(data){
        apiDeployManagement.queryConCommonMessageVoTreePage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              if (res.result.list && res.result.list.length > 0) {
                this.commonWordsTrees = JSON.parse(JSON.stringify(res.result.list))
                this.oftenTreeData = res.result.list
              } else {
                this.oftenTreeData = []
              }
              this.isOften = 0
              this.totalNumTrees = res.result.total
              // this.brushTree(this.commonWordsList)
            } else {
              this.oftenTreeData = []
              this.totalNumTrees = 0
            }
          }
        })
      },
      /*常用语树形切换分页条数*/
      pageSizeChangeTrees(val){
        this.pageSizeTrees = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          messageType: this.oftenID == 0 ? 0 : this.oftenID == 1 ? 1 : '',
          username: this.oftenID == 1 ? this.userInfo.userName : '',
          pageNum: this.currentPageTrees,
          pageSize: val,
        }
        this.getCommonMessageVoTrees(data)
      },
      /*常用语树形切换历史会话当前页*/
      currentChangeTrees(val) {
        this.currentPageTrees = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          messageType: this.oftenID == 0 ? 0 : this.oftenID == 1 ? 1 : '',
          username: this.oftenID == 1 ? this.userInfo.userName : '',
          pageNum: val
        }, arr = {}, newData = {}
        if (Util.isNotEmpty(this.searchKey)) {
          this.pageSizeTrees = 100
          arr = {
            keyWords: this.searchKey,
            pageSize: this.pageSizeTrees
          }
          newData = { ...data, ...arr }
          this.getSearchConCommonMessageVoTrees(newData)
        } else {
          this.pageSizeTrees = 10
          arr = {
            pageSize: this.pageSizeTrees
          }
          newData = { ...data, ...arr }
          this.getCommonMessageVoTrees(data)
        }
      },
      /*刷选公共常用语树数据*/
      searchCommonMessageVoTrees(messageType, username){
        this.currentPageTrees = 1
        this.pageSizeTrees = 100
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          messageType: messageType,
          username: username,
          keyWords: this.searchKey,
          pageNum: this.currentPageTrees,
          pageSize: this.pageSizeTrees,
        }
        this.getSearchConCommonMessageVoTrees(data)
      },
      getSearchConCommonMessageVoTrees(data){
        apiDeployManagement.searchConCommonMessageListPage(data).then(res => {
          if (res.code == 0) {
            this.isOften = 0
            if (res.result) {
              if (res.result.list && res.result.list.length > 0) {
                this.oftenTreeBrushData = res.result.list
              } else {
                this.oftenTreeBrushData = []
              }
              this.totalNumTrees = res.result.total
            } else {
              this.oftenTreeBrushData = []
              this.totalNumTrees = 0
            }
          }
        })
      },
      /*常用链接、文件、图片选择*/
      initResourceLis(resourceType) {
        let data = {
          companyId: this.userInfo.companyId,
          resourceType: resourceType
        }
        apiDeployManagement.queryConCommonResourceList(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.isOften = 1
              this.commonWordsTrees = JSON.parse(JSON.stringify(res.result))
              this.brushTree(this.commonWordsList)
            } else {
              this.oftenTreeData = []
            }
          }
        })
      },
      /*常用语选择*/
      isDisabled(data) {
        let disabled
        if (Util.isEmpty(data)) return disabled = 'disabled'
      },
      /*历史会话*/
      initHistoricalSession() {
        if (Util.isNotEmpty(this.clientChatInfo)) {
          let data = {
            userToken: this.clientChatInfo.userToken,
            pageNum: this.currentPageHistorical
          }
          this.getAssessmentSession(data, 0)
        } else {
          this.historyList = []
          this.totalNumHistorical = 0
        }
      },
      /*切换历史会话当前页*/
      currentChangeHistorical(val) {
        this.currentPageHistorical = val
        let data = {
          pageNum: val,
          serviceToken: this.userInfo.userToken
        }
        this.getAssessmentSession(data, 0)
      },
      /*历史会话详情*/
      goChatDetailPop(obj) {
        this.isToChatDetailPop = true
        this.historyChatDetailInfo = obj
        this.chatLevelHistoricalTc = obj.sessionLevel
        this.chatThemeHistoricalTc = obj.sessionTopic
        this.historyChatDetailReason = obj.assessmentContent
        this.initUserInfo(2, obj.userToken)
        this.getChatMessageList(obj.sessionId)
      },
      /*保存评估信息*/
      saveUserAccess() {
        if (Util.isNotEmpty(this.chatLevelHistoricalTc) && Util.isNotEmpty(this.chatThemeHistoricalTc)) {
          let data = {
            id: this.historyChatDetailInfo.id,
            sessionLevel: this.chatLevelHistoricalTc,
            sessionTopic: this.chatThemeHistoricalTc,
            assessmentContent: this.historyChatDetailReason
          }
          apiChatSystem.updateBizUserAccess(data).then(res => {
            if (res.code == 0 && res.result == true) {
              this.$message.success(window.$t('im.commonChat.evaluatedSuc'))
              this.isToChatDetailPop = false
              this.initHistoricalSession()
            }
          })
        } else {
          this.$message.error(window.$t('im.commonChat.isNotNull'))
        }
      },
      /*删除客服消息数量*/
      delChatMessage(sessionId, type, messageCount) {
        let messageCounts
        if (type == 0) {
          messageCounts = messageCount
        } else {
          messageCounts = this.messageCount
        }
        if (messageCounts && messageCounts[sessionId] > 0) {
          let data = {
            sessionId: sessionId
          }
          apiChatSystem.deleteUserMessageCount(data).then(res => {
            if (res.code == 0 && res.result == true) {
              messageCounts[sessionId] = 0
              imStore.dispatch('setMessageNums', JSON.parse(JSON.stringify(messageCounts)))
            }
          })
        }
      },
      /*刷选业务列表*/
      brushBusinessGroup(obj) {
        for (const j in this.businessGroupData) {
          if (this.businessGroupData[j].code == obj.bizCode) {
            obj.bizCodeName = this.businessGroupData[j].name
          }
        }
        return obj
      },
      /*刷选访客方式*/
      brushClientType(obj) {
        for (const j in this.clientTypeData) {
          if (this.clientTypeData[j].id == obj.clientType) {
            obj.clientName = this.clientTypeData[j].name
          }
        }
        return obj
      },
      /*刷选用户类型*/
      brushUserType(obj) {
        for (const j in this.userTypeData) {
          if (this.userTypeData[j].id == obj.userType) {
            obj.userTypeName = this.userTypeData[j].name
          }
        }
        return obj
      },
      /*刷选性别*/
      brushSex(obj) {
        for (const j in this.sexData) {
          if (this.sexData[j].id == obj.sex) {
            obj.sexName = this.sexData[j].name
          }
        }
        return obj
      },
      /*刷选语言*/
      brushLocale(obj) {
        for (const j in this.langList) {
          if (this.langList[j].id == obj.locale) {
            obj.localeName = this.langList[j].name
          }
        }
        return obj
      },
      /*选择表格时的样式*/
      getCurrentChange(obj) {
        this.currentRow = obj
      },
      /*接受聊天*/
      getConnectSession(obj, type, messageCounts) {
        this.isEdit = true
        let sessionIdMap = {}, sessionStatusMap = {}
        if (Util.isNotEmpty(obj)) {
          this.clientChatInfo = obj
          if (type != 0) {
            this.isFirst = false
            imStore.dispatch('setIntelligentSessionId', '')
          }
          this.brushBusinessGroup(obj)
          this.$nextTick(() => {
            setTimeout(() => {
              if (Util.isNotEmpty(this.$refs.initTable)) {
                this.$refs.initTable.setCurrentRow(obj)
              }
            }, 10)
          })
          sessionIdMap[this.userToken] = obj.sessionId
          imStore.dispatch('setSessionId', sessionIdMap)
          sessionStatusMap[this.userToken] = obj.sessionStatus
          imStore.dispatch('setSessionStatus', sessionStatusMap)
          this.langId = obj.locale
          this.chatLevel = obj.sessionLevel
          this.chatTheme = obj.sessionTopic
          this.assessmentContent = obj.assessmentContent
          this.initUserInfo(0, obj.userToken)
          this.initHistoricalSession()
          this.delChatMessage(obj.sessionId, type, messageCounts)
          this.getCurrentSession(obj.sessionId)
        }
        if (Util.isEmpty(obj)) {
          imStore.dispatch('setIntelligentSessionId', '')
          if (this.sessionIds[this.userToken]) this.sessionIds[this.userToken] = ''
          if (this.sessionStatus[this.userToken]) this.sessionStatus[this.userToken] = 1
          this.clientChatInfo = ''
          imStore.dispatch('setSessionId', this.sessionIds)
          imStore.dispatch('setSessionStatus', this.sessionStatus)
          this.langId = 'zh_CN'
          this.chatLevel = ''
          this.chatTheme = ''
          this.assessmentContent = ''
          this.initUserInfo(0)
          this.initHistoricalSession()
          this.delChatMessage()
          this.getCurrentSession('')
        }
      },
      /*选择资源*/
      selectionResource(val) {
        if (val.length > 0) {
          this.multipleSelection = val
        } else {
          this.multipleSelection = []
        }
      },
      goWaitAccept() {
        this.isToAccessed = true
        this.initWaitAcceptList()
      },
      /*初始化待接入会话列表*/
      initWaitAcceptList() {
        let data = {
          userToken: this.userInfo.userToken
        }
        apiChatSystem.queryWaitAcceptList(data).then(res => {
          if (res.code == 0) {
            if (this.sendType == 1) this.isToAccessed = true
            if (res.result) {
              let newData = JSON.parse(JSON.stringify(res.result))
              for (const i in newData) {
                this.brushBusinessGroup(newData[i])
              }
              this.WaitAcceptList = newData
            } else {
              this.WaitAcceptList = []
            }
          }
        })
      },
      /*接入会话列表*/
      accessChatList(obj) {
        let data = {
          userToken: this.userInfo.userToken,
          sessionId: obj.sessionId
        }
        apiChatSystem.connectSession(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.commonChat.acceptSuc'))
            this.initWaitAcceptList()
          } else {
            this.$message.error(window.$t('im.commonChat.acceptFail'))
          }
        })
      },
      /*全部接入会话列表*/
      allAccessChatList() {
        let data = {
          userToken: this.userInfo.userToken
        }
        apiChatSystem.connectAllSession(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.isToAccessed = false
          } else {
            this.$message.error(window.$t('im.commonChat.acceptFail'))
          }
        })
      },
      /*传送对话*/
      getSendSession(obj, type) {
        this.sendType = type
        if (obj.customerId) {
          if (this.multipleSelection.length > 1) {
            this.$message(window.$t('im.commonChat.sendSingle'))
          } else if (this.multipleSelection.length == 1 || Util.isNotEmpty(this.currentRow.sessionId)) {
            if (obj.transferStatus == 1) {
              this.$message(window.$t('im.commonChat.hasSend'))
            } else {
              this.isToAssessment = false
              this.isToSendChatInfo = true
              this.getOnlineServiceList(obj)
            }
          }
        } else {
          this.$message(window.$t('im.commonChat.checkSend'))
        }
      },
      cancelSendSession() {
        this.isToSendChatInfo = false
        this.sendReason = ''
        if (this.OnlineChatList.length > 0) {
          this.sendRadio = this.OnlineChatList[0]
        }
      },
      /*选择传送人*/
      changeSendSession(obj) {
        this.sendRadio = obj
      },
      /*保存传送对话数据*/
      saveSendSession() {
        if (Util.isEmpty(this.sendRadio)) {
          this.$message(window.$t('im.commonChat.notSender'))
        } else {
          let data = {
            serviceToken: this.userInfo.userToken,
            serviceName: this.userInfo.displayName,
            sessionId: this.clientChatInfo.sessionId,
            transferName: this.sendRadio.name,
            transferReason: this.sendReason,
            transferToken: this.sendRadio.userToken,
            bizCode: this.clientChatInfo.bizCode
          }
          apiChatSystem.sendSession(data).then(res => {
            if (res.code == 0 && res.result == true) {
              this.$message.success(window.$t('im.commonChat.sendSuc'))
              this.isToSendChatInfo = false
              this.sendReason = ''
              this.initWaitAcceptList()
            } else {
              this.$message.error(window.$t('im.commonChat.sendFail'))
            }
          })
        }
      },
      /*待评估*/
      goEvaluated() {
        this.isToAssessment = true
        this.initAssessmentSession()
      },
      /*获取待评估列表或历史列表*/
      getAssessmentSession(data, type) {//0：历史会话，1：待评估
        apiChatSystem.querySessionListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result.list && res.result.list.length > 0) {
              let newData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in newData) {
                this.brushBusinessGroup(newData[i])
                if (newData[i].endReason == 0) {
                  newData[i].endReasonName = window.$t('im.commonChat.customerOff')
                } else if (newData[i].endReason == 1) newData[i].endReasonName = window.$t('im.commonChat.chatClose')
              }
              if (type == 0) {
                this.historyList = newData
              } else if (type == 1) this.evaluatedList = newData
            } else {
              if (type == 0) {
                this.historyList = []
              } else if (type == 1) this.evaluatedList = []
            }
            if (type == 0) {
              this.totalNumHistorical = res.result.total
            } else if (type == 1) this.totalNumAssessment = res.result.total
          }
        })
      },
      /*待评估列表*/
      initAssessmentSession() {
        let data = {
          assessmentStatus: 0,
          serviceToken: this.userInfo.userToken,
          companyId: this.userInfo.companyId,
          pageNum: this.currentPageAssessment,
          pageSize: this.pageSizeAssessment
        }
        this.getAssessmentSession(data, 1)
      },
      /*切换待评估分页条数*/
      pageSizeChangeAssessment(val) {
        this.pageSizeAssessment = val
        let data = {
          pageSize: val,
          pageNum: this.currentPageAssessment,
          assessmentStatus: 0,
          serviceToken: this.userInfo.userToken,
          companyId: this.userInfo.companyId
        }
        this.getAssessmentSession(data, 1)
      },
      /*切换待评估当前页*/
      currentChangeAssessment(val) {
        this.currentPageAssessment = val
        let data = {
          pageNum: val,
          pageSize: this.pageSizeAssessment,
          assessmentStatus: 0,
          serviceToken: this.userInfo.userToken,
          companyId: this.userInfo.companyId
        }
        this.getAssessmentSession(data, 1)
      },
      tableRowClassName({ row, rowIndex }) {
        //把每一行的索引放进row
        row.index = rowIndex
      },
      /*打开具体会话待评估信息弹窗*/
      goAssessmentSessionPop(obj) {
        this.isToAssessmentSomeone = true
        this.evaluatedIndex = obj.index
        this.evaluatedInfo = obj
        this.initUserInfo(1, obj.userToken)
        this.chatLevelTc = obj.sessionLevel
        this.chatThemeTc = obj.sessionTopic
        this.evaluatedReason = obj.assessmentContent
        this.getChatMessageList(obj.sessionId)
      },
      /*客服与某位用户的聊天记录*/
      getChatMessageList(sessionId) {
        if (Util.isNotEmpty(sessionId)) {
          let data = {
            sessionId: sessionId
          }
          apiChatSystem.queryUserChatMessageList(data).then(res => {
            if (res.code == 0) {
              if (res.result.length > 0) {
                this.chatRecord = res.result
              } else {
                this.chatRecord = []
              }
            }
          })
        } else {
          this.chatRecord = []
        }
      },
      /*客服评估*/
      saveAssessmentStatus() {
        if (Util.isNotEmpty(this.chatLevelTc) && Util.isNotEmpty(this.chatThemeTc)) {
          let data = {
            serviceToken: this.userInfo.userToken,
            id: this.evaluatedInfo.id,
            sessionLevel: this.chatLevelTc,
            sessionTopic: this.chatThemeTc,
            assessmentContent: this.evaluatedReason,
            assessmentStatus: 1
          }
          apiChatSystem.updateAssessmentStatus(data).then(res => {
            if (res.code == 0 && res.result == true) {
              for (const i in this.evaluatedList) {
                if (i == this.evaluatedIndex) {
                  this.initAssessmentSession()
                  if ((Number(i) + 1) < this.evaluatedList.length) {
                    this.$message.success(window.$t('im.commonChat.evaluatedSuc'))
                    this.evaluatedInfo = this.evaluatedList[Number(i) + 1]
                    this.chatLevelTc = this.evaluatedList[Number(i) + 1].sessionLevel
                    this.chatThemeTc = this.evaluatedList[Number(i) + 1].sessionTopic
                    this.evaluatedReason = this.evaluatedList[Number(i) + 1].assessmentContent
                    this.initUserInfo(1, this.evaluatedList[Number(i) + 1].userToken)
                    this.getChatMessageList(this.evaluatedList[Number(i) + 1].sessionId)
                  }
                }
              }
              this.evaluatedIndex++
              if (this.evaluatedIndex >= this.evaluatedList.length) {
                this.$message.success(window.$t('im.chatRecord.saveSuc'))
              }
              if (this.evaluatedList.length == 1) this.currentPageAssessment -= 1
            }
          })
        } else {
          this.$message.error(window.$t('im.commonChat.isNotNull'))
        }
      },
      nextAssessmentStatus(){
        for (const i in this.evaluatedList) {
          if (i == this.evaluatedIndex) {
            if ((Number(i) + 1) < this.evaluatedList.length) {
              this.evaluatedInfo = this.evaluatedList[Number(i) + 1]
              this.chatLevelTc = this.evaluatedList[Number(i) + 1].sessionLevel
              this.chatThemeTc = this.evaluatedList[Number(i) + 1].sessionTopic
              this.evaluatedReason = this.evaluatedList[Number(i) + 1].assessmentContent
              this.initUserInfo(1, this.evaluatedList[Number(i) + 1].userToken)
              this.getChatMessageList(this.evaluatedList[Number(i) + 1].sessionId)
            }
          }
        }
        this.evaluatedIndex++
        if (this.evaluatedIndex >= this.evaluatedList.length) {
          this.$message.info(window.$t('im.chatRecord.noNext'))
        }
        if (this.evaluatedList.length == 1) this.currentPageAssessment -= 1
      },
      goAcceptSession() {
        this.isToAcceptChatInfoList = true
        this.initAcceptSession()
      },
      /*接受对话*/
      initAcceptSession() {
        let data = {
          userToken: this.userInfo.userToken
        }
        apiChatSystem.querySendSessionList(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let newData = JSON.parse(JSON.stringify(res.result))
              for (const i in newData) {
                this.brushBusinessGroup(newData[i])
              }
              this.acceptChatList = newData
            } else {
              this.acceptChatList = []
            }
          }
        })
      },
      /*保存接受对话数据*/
      acceptChatSession(obj) {
        this.$confirm(window.$t('im.commonChat.isAccept'), window.$t('im.common.tip'), {
          confirmButtonText: window.$t('im.bt.definite'),
          cancelButtonText: window.$t('im.bt.cancel'),
          type: 'warning',
          center: true
        }).then(() => {
          apiChatSystem.acceptSession(obj).then(res => {
            if (res.code == 0 && res.result == true) {
              this.$message.success(window.$t('im.commonChat.receptionSuc'))
              this.initAcceptSession()
            } else {
              this.$message.error(window.$t('im.commonChat.receptionFail'))
            }
          })
        }).catch(() => {
          this.$message.info(window.$t('im.commonChat.receptionCancel'))
        })
      },
      /*拒绝接受对话数据*/
      rejectChatSession(obj) {
        this.$confirm(window.$t('im.commonChat.isRefusal'), window.$t('im.common.tip'), {
          confirmButtonText: window.$t('im.bt.definite'),
          cancelButtonText: window.$t('im.bt.cancel'),
          type: 'warning',
          center: true
        }).then(() => {
          let data = obj
          apiChatSystem.rejectSession(obj).then(res => {
            if (res.code == 0 && res.result == true) {
              this.$message.success(window.$t('im.commonChat.refusalSuc'))
              this.initAcceptSession()
            } else {
              this.$message.error(window.$t('im.commonChat.refusalFail'))
            }
          })
        }).catch(() => {
          this.$message.info(window.$t('im.commonChat.refusalCancel'))
        })
      },
      /*结束会话*/
      endSession() {
        let sessionIds = []
        for (const i in this.multipleSelection) {
          sessionIds.push(this.multipleSelection[i].sessionId)
        }
        let data = {
          userToken: this.userInfo.userToken,
          sessionIds: sessionIds.join(',')
        }
        if (this.multipleSelection.length > 0) {
          apiChatSystem.finishSession(data).then(res => {
            if (res.code == 0 && res.result == true) {
              this.isFirst = true
              this.$message.success(window.$t('im.commonChat.chatEnds'))
            } else {
              this.$message.error(window.$t('im.commonChat.chatEndsFail'))
            }
          })
        } else {
          this.$message(window.$t('im.commonChat.checkChatEnds'))
        }
      },
      /*在线客服列表*/
      getOnlineServiceList(obj) {
        let data = {
          userToken: this.userInfo.userToken,
          companyId: obj.companyId,
          locale: obj.locale,
          bizCode: obj.bizCode
        }
        apiChatSystem.querySendOnlineServiceList(data).then(res => {
          if (res.code == 0) {
            if (res.result && res.result.length > 0) {
              this.OnlineChatList = res.result
              this.sendRadio = res.result[0]
            } else {
              this.OnlineChatList = []
              this.sendRadio = ''
            }
          }
        })
      },
      /*客服监控*/
      goChatMonitor() {
        this.isChatMonitor = true
        this.initThisList()
      },
      goLimitVisitorsIP() {
        if (this.chatData && this.chatData.length <= 0) {
          this.$message(window.$t('im.commonChat.checkChat'))
        } else {
          this.isLimitVisitorsIP = true
          if (this.radioTxt == 0) {
            this.radioContent = this.clientChatInfo.userIp
          } else if (this.radioTxt == 1) {
            this.radioContent = this.clientChatInfo.account
          }
        }
      },
      initAutoReplyStatus(){
        let data = {
          companyId: this.userInfo.companyId,
          userToken: this.userInfo.userToken
        }
        apiChatSystem.queryAutoAnswerStatus(data).then(res => {
          if (res.code == 0) {
            if (res.result == 0) this.autoReplyStatus = false
            if (res.result == 1) this.autoReplyStatus = true
          }
        })
      },
      autoReplySetting() {
        let data = {
          companyId: this.userInfo.companyId,
          userToken: this.userInfo.userToken,
          autoAnswerStatus: this.autoReplyStatus ? 0 : 1
        }
        apiChatSystem.updateAutoAnswerStatus(data).then(res => {
          if (res.code == 0) {
            this.autoReplyStatus = !this.autoReplyStatus
          }
        })
      },
      /*选择账户或IP*/
      visitorsIPType(data) {
        this.radioTxt = data
        if (data == 0) {
          this.radioContent = this.clientChatInfo.userIp
        } else if (data == 1) {
          this.radioContent = this.clientChatInfo.account
        }
      },
      /*新增数据*/
      addVisitorsIP() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          accountType: this.radioTxt,
          bizCode: this.clientChatInfo.bizCode,
          account: this.radioContent,
          remark: this.contentTxt
        }
        apiDeployManagement.addConAccessLimit(data).then(res => {
          if (res.code == 0) {
            this.isLimitVisitorsIP = false
          }
        })
      },
      /*保存数据*/
      submitSave() {
        if (Util.isNotEmpty(this.contentTxt.replace(/\s/g, ''))) {
          this.addVisitorsIP()
        }
      },
      /*初始化客服列表*/
      initThisList() {
        let data = { companyId: this.userInfo.companyId }
        apiChatSystem.getThisList(data).then(res => {
          if (res.code == 0) {
            if (res.result && res.result.length > 0) {
              let oldData = JSON.parse(JSON.stringify(res.result)), newData = []
              for (const i in oldData) {
                if (oldData[i].id != this.userInfo.id) {
                  if (this.serviceStatusInfo[oldData[i].userToken] == 0) newData.push(oldData[i])
                }
              }
              this.chatMonitorData = newData
            }
          }
        })
      },
      /*跳转客服监控*/
      addChatMonitor(obj) {
        this.isChatMonitor = false
        let dataMap = {}
        dataMap[obj.userToken] = obj
        imStore.dispatch('setMonitorChat', dataMap)
        this.getChatMonitor(obj)
      },
      /*开始监控*/
      getChatMonitor(obj) {
        let data = {
          monitor: this.userInfo.userToken,
          serviceToken: obj.userToken
        }
        apiChatSystem.addMonitor(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.commonChat.startMonitor') + obj.displayName)
            this.userToken = obj.userToken
            let url = '/chatSystem/chatSystem/' + obj.userToken
            this.$router.push({
              path: url,
              query: { label: 'IM', id: obj.userToken }
            })
          } else {
            this.$message.error(window.$t('im.commonChat.monitorFail1') + obj.displayName + window.$t('im.commonChat.monitorFail2'))
          }
        })
      },
      /*更新当前监控客服的会话列表*/
      getCurrentSession(sessionId) {
        let data = {
          serviceToken: this.userInfo.userToken,
          sessionId: sessionId
        }
        apiChatSystem.updateServiceCurrentSession(data).then(res => {
          if (res.code == 0 && res.result == true) {
          } else {
          }
        })
      },
      /*查询当前监控客服的会话列表选择栏*/
      getCurrentMonitorSession(type, messageCounts) {
        let data = {
          serviceToken: this.userID
        }
        apiChatSystem.queryServiceCurrentSession(data).then(res => {
          if (res.code == 0) {
            if (this.chatData.length > 0) {
              for (const i in this.chatData) {
                if (this.chatData[i].sessionId == res.result) {
                  this.$nextTick(() => {
                    setTimeout(() => {
                      if (Util.isNotEmpty(this.$refs.initTable)) {
                        this.$refs.initTable.setCurrentRow(this.chatData[i])
                      }
                    }, 10)
                  })
                  this.getConnectSession(this.chatData[i], type, messageCounts)
                }
              }
            }
          } else {
            if (this.chatData.length > 0) {
              this.$nextTick(() => {
                setTimeout(() => {
                  if (Util.isNotEmpty(this.$refs.initTable)) {
                    this.$refs.initTable.setCurrentRow(this.chatData[0])
                  }
                }, 10)
              })
              this.getConnectSession(this.chatData[0], type)
            }
          }
        })
      }
    },
    mounted() {
      this.docHeight()
      this.initTcBusinessGroup()
      this.initChatList(0)
      this.initChatList(1)
      this.initAutoReplyStatus()
      if (this.chatType == 0) imStore.dispatch('setIntelligentSessionId', '')
    },
    watch: {
      messageCount: {
        deep: true,
        handler(newVal, oldVal) {
          if (newVal != oldVal && newVal) {
            if (this.isFirst && this.chatType == 1) {
              if (this.chatData.length > 0) {
                if (Util.isNotEmpty(this.userID)) {
                  this.getCurrentMonitorSession(0, newVal)
                } else {
                  if (Util.isNotEmpty(this.intelligentSessionIds)) {
                    for (const i in this.chatData) {
                      if (this.intelligentSessionIds == this.chatData[i].sessionId) {
                        this.$nextTick(() => {
                          setTimeout(() => {
                            if (Util.isNotEmpty(this.$refs.initTable)) {
                              this.$refs.initTable.setCurrentRow(this.chatData[i])
                            }
                          }, 10)
                        })
                        this.getConnectSession(this.chatData[i], 0, newVal)
                      }
                    }
                  } else {
                    this.$nextTick(() => {
                      setTimeout(() => {
                        if (Util.isNotEmpty(this.$refs.initTable)) {
                          this.$refs.initTable.setCurrentRow(this.chatData[0])
                        }
                      }, 10)
                    })
                    this.getConnectSession(this.chatData[0], 0, newVal)
                  }
                }
              }
            }
          }
        }
      },
      chatData: {
        deep: true,
        handler(newVal, oldVal) {
          let sessionStatusMap = {}, flag = false
          if (newVal.length > 0) {
            if (!this.isFirst || this.chatType == 0) {
              for (const i in newVal) {
                if (newVal[i].sessionId == (this.sessionIds[this.userToken] || this.acceptSessionIds[this.userToken])) {
                  flag = true
                  sessionStatusMap[this.userToken] = newVal[i].sessionStatus
                  imStore.dispatch('setSessionStatus', sessionStatusMap)
                  this.$nextTick(() => {
                    setTimeout(() => {
                      if (Util.isNotEmpty(this.$refs.initTable)) {
                        this.$refs.initTable.setCurrentRow(newVal[i])
                      }
                    }, 10)
                  })
                  this.getConnectSession(newVal[i])
                }
              }
              if (!flag) {
                sessionStatusMap[this.userToken] = newVal[0].sessionStatus
                imStore.dispatch('setSessionStatus', sessionStatusMap)
                this.$nextTick(() => {
                  setTimeout(() => {
                    if (Util.isNotEmpty(this.$refs.initTable)) {
                      this.$refs.initTable.setCurrentRow(newVal[0])
                    }
                  }, 10)
                })
                this.getConnectSession(newVal[0])
              }
            }
            if (this.isFirst && this.chatType == 0) {
              this.$nextTick(() => {
                setTimeout(() => {
                  if (Util.isNotEmpty(this.$refs.initTable)) {
                    this.$refs.initTable.setCurrentRow(newVal[0])
                  }
                }, 10)
              })
              this.getConnectSession(newVal[0], 0)
            }
          }
          if (newVal.length == 0) {
            setTimeout(() => {
              this.getConnectSession()
            }, 300)
          }
        }
      },
      monitorSessionIds: {
        deep: true,
        handler(newVal, oldVal) {
          if (this.chatData.length > 0) {
            for (const i in this.chatData) {
              if (this.chatData[i].sessionId == newVal[this.userID]) {
                this.$nextTick(() => {
                  setTimeout(() => {
                    if (Util.isNotEmpty(this.$refs.initTable)) {
                      this.$refs.initTable.setCurrentRow(this.chatData[i])
                    }
                  }, 10)
                })
                this.getConnectSession(this.chatData[i])
              }
            }
          }
        }
      },
    }
  }
</script>
